import { render } from "./weekly-overview.vue?vue&type=template&id=e1defe24"
import script from "./weekly-overview.vue?vue&type=script&lang=js"
export * from "./weekly-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__